"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NIGHTS_VALUES = void 0;

var _localization = require("@lt/localization");

var NIGHTS_VALUES = [_localization.i18n.t('hotel.offer.night', {
  count: 0
}), _localization.i18n.t('hotel.offer.night', {
  count: 1
}), _localization.i18n.t('hotel.offer.night', {
  count: 2
})];
exports.NIGHTS_VALUES = NIGHTS_VALUES;